export const state = () => ({
  list: [],
});

export const actions = {
  async GET_BANNERS({ commit }) {
    try {
      const { data } = await this.$axios.$get('/api/banners');
      await commit('SET_BANNERS_DATA', data);
    } catch (e) {}
  },

  async DISMISS_BANNER({ commit }, id) {
    try {
      await commit('DISMISS_BANNER', id);
      await this.$axios.$put(`/api/banners/dismiss/${id}`);
    } catch (e) {}
  },
};

export const mutations = {
  SET_BANNERS_DATA(state, data) {
    state.list = data;
  },
  DISMISS_BANNER(state, id) {
    state.list = state.list.filter(item => item.id !== id);
  },
};
